exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".RosteringMethodPreference .saveAction{float:right}.RosteringMethodPreference .section{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/org/preferences/rostering_method_preference.scss
// module id = 1362
// module chunks = 0